import { TFunction } from 'i18next';
import * as Yup from 'yup';
import { ISocialNetwork } from 'core/interface/aboutMe';

const initialValues: ISocialNetwork = {
  network: '',
  url: ''
};

const validationSchema = (t: TFunction) => {
  return Yup.object({
    id: Yup.number().optional(),
    network: Yup.string().required(t('required')),
    url: Yup.string()
      .required(t('required'))
      .test('isValidURL', t('Invalid URL'), (value) => {
        if (!value) {
          return true;
        }
        // If URL doesn't have protocol, add https:// prefix
        const urlWithProtocol = value.match(/^(https?|ftp):\/\//)
          ? value
          : `https://${value}`;
        return /^(ftp|http|https):\/\/[^ "]+$/.test(urlWithProtocol);
      })
  });
};

export { initialValues, validationSchema };
